import React, { useEffect, useState,useRef } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  Paper,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import shareIcon from "../../image/dashboard/share.svg";
import copyIcon from "../../image/dashboard/copy.svg";
import qr from "../../image/dashboard/qr.png";
import next from "../../image/dashboard/next.svg";
import { getReferralCode } from "../../../service/services";
import { toast } from "react-toastify";
import QrGenerator from "../../qrGenerator/QrGenerator";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "1.5rem",
    backgroundColor: "#fff",
    maxWidth: "1200px",
    margin: "auto",
    marginBottom: "1rem",
    ["@media (max-width:600px)"]: {
      padding: "0rem",
    },
  },

  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    ["@media (max-width:600px)"]: {
      padding: "0.5rem",
    },
  },
  paper2: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  inputBox: {
    marginTop: "1rem",
    background: "linear-gradient(90deg, #FFD9B5 0%, #FFEEC3 100%)",
    padding: "1rem",
    borderRadius: "8px",
    ["@media (max-width:600px)"]: {
      padding: "0.4rem",
    },
  },
  inputInnerBox: {
    display: "flex",
    alignItems: "center",
    background: "white",
    borderRadius: "8px",
    marginTop: "8px",
  },
  referralInput: {
    flex: 1,
    backgroundColor: "#fff",
    borderRadius: "4px",
    marginRight: "0.5rem",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "0",
      },
      "&:hover fieldset": {
        border: "0",
      },
      "&.Mui-focused fieldset": {
        border: "0",
      },
      outline: "none",
    },
    "& .MuiOutlinedInput-input": {
      fontWeight: 700,
    },
  },

  qrBox: {
    display: "flex",
    flexDirection: "row",
    // flexWrap: "wrap",
    textAlign: "center",
    marginTop: "1.5rem",
    justifyContent: "center",
    gap: "1rem",
    ["@media (max-width:600px)"]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },

  qrImage: {
    margin: "0 auto 1rem",
    padding: "1rem",
    background: "linear-gradient(90deg, #FFD9B5 0%, #FFEEC3 100%)",
    borderRadius: "8px",
  },
  howItWorks: {
    backgroundColor: "#FFFCF4",
    padding: "1rem",
    borderRadius: "8px",
    marginBottom: "1rem",
    border: "2px solid #FFBF35",
  },
  walletBox: {
    backgroundColor: "#FAFAFA",
    padding: "1.5rem",
    textAlign: "center",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "1.2rem",
  },
  btn: {
    color: "var(--text-color, #212121)",
    textAlign: "center",
    fontSize: "0.9375rem",
    fontWeight: 300,
    textTransform: "uppercase",
    // width: "100% ",
    padding: "0.5rem",
    margin: "0.5rem",
    background: "linear-gradient(90deg, #141E30 0%, #243B55 100%)",
    color: "white",
  },
  btn2: {
    textAlign: "center",
    fontSize: "0.9375rem",
    fontWeight: 300,
    textTransform: "uppercase",
    // width: "100% ",
    padding: "0.5rem",
    margin: "0.5rem",
    background: "linear-gradient(90deg, #FFDE87 0%, #FFB36B 100%)",
    color: "white",
  },
  qrDetailBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90%",
    // background:'red'
  },
  qrDetailBoxHeading: {
    textAlign: "start",
    padding: "0px 1rem",
    paddingBottom: "0.5rem",
  },
  hideOnMobile: {
    ["@media (max-width:600px)"]: {
      display: "none",
    },
  },
  boldHeading: {
    fontWeight: 700,
  },
  rupeeIcon: {
    fontSize: "1rem",
    verticalAlign: "super",
    marginRight: "2px",
  },
}));

const ReferAndEarn = () => {
  const classes = useStyles();
  const [code, setCode] = useState("");
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalEarning, setTotalEarning] = useState(0);
  const [url, setUrl] = useState('');


  const fetchData = async () => {
    try {
      const response = await getReferralCode();
      setCode(response.data.referral_code);
      setTotalBalance(response.data.total_balance);
      setTotalEarning(response.data.total_earning);
      setUrl(`${process.env.REACT_APP_API_REFERRAL_URL}?signup=true&referral_code=${response.data.referral_code}`)

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const qrRef = useRef(null);

  const downloadQR = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;

    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qr-code.png';
    downloadLink.click();
  };

  const shareQR = async () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas || !navigator.share) {
      toast.error("Sharing is not supported on this browser.");
      return;
    }

    canvas.toBlob(async (blob) => {
      const file = new File([blob], "qr.png", { type: "image/png" });

      try {
        await navigator.share({
          title: "Join me on Parikshado!",
          text: "Scan to sign up and earn rewards!",
          files: [file],
        });
      } catch (err) {
        console.error("Share failed:", err);
      }
    });
  };

  const handleCopy = () => {
    const link =url
    navigator.clipboard
      .writeText(link)
      .then(() => toast.success("Link copied to clipboard!"))
      .catch((err) => console.error("Copy failed:", err));
  };

  const handleShare = () => {
    const shareUrl = url

    if (navigator.share) {
      navigator
        .share({
          title: "Check this out!",
          text: "Join using my referral link",
          url: shareUrl,
        })
        .then(() => console.log("Shared successfully"))
        .catch((err) => console.error("Sharing failed:", err));
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <>
      <Box className={classes.container}>
        <Paper className={classes.paper} elevation={1}>
          <Grid container spacing={2} mt={4}>
            <Grid item xs={12} md={8}>
              <Typography variant="h5" gutterBottom>
                Share The Platform You Trust — And Get Rewarded!
              </Typography>
              <Typography>
                At ParishkaDO, We Believe in Growing Together. Now, You Can Earn
                Real Rewards Just By Inviting Your Friends, Students, Or Fellow
                Educators.
              </Typography>
              <Box className={classes.inputBox}>
                <Typography>Your Invitation Link</Typography>
                <Box className={classes.inputInnerBox}>
                  <TextField
                    value={code}
                    variant="outlined"
                    size="small"
                    InputProps={{ readOnly: true }}
                    className={classes.referralInput}
                  />
                  <img
                    className={classes.hideOnMobile}
                    style={{ height: "20px", marginRight: "0.5rem",cursor:'pointer' }}
                    src={copyIcon}
                    alt="copy"
                    onClick={handleCopy}
                  />

                  <Button
                    className={classes.btn}
                    onClick={handleShare}
                    startIcon={
                      <img
                        style={{ height: "20px" }}
                        src={shareIcon}
                        alt="Share"
                      />
                    }
                  >
                    Share Link
                  </Button>
                </Box>
              </Box>
              <Box sx={{ margin: "1rem" }}>
                <Typography variant="h5" align="center">
                  OR
                </Typography>
              </Box>

              {/* QR Section */}
              <Box className={classes.qrBox}>
                <Box className={classes.qrImage}>
                  {/* <img style={{ height: "120px" }} src={qr} alt="qr" /> */}
                  <QrGenerator link={url} qrRef={qrRef} />
                  <Typography>Invite. Earn. Repeat.</Typography>
                </Box>
                <Box>
                  <Box className={classes.qrDetailBox}>
                    <Box>
                      <Typography className={classes.qrDetailBoxHeading}>
                        Scan & Share Instantly
                      </Typography>
                      <Typography className={classes.qrDetailBoxHeading}>
                        Scan the QR code and share your referral link with
                        friends in just a tap!{" "}
                      </Typography>
                    </Box>
                    <Box>
                      <Button
                      onclick={shareQR}
                        className={classes.btn}
                        startIcon={
                          <img
                            style={{ height: "20px" }}
                            src={shareIcon}
                            alt="Share"
                          />
                        }
                      >
                        Share QR
                      </Button>
                      <Button onClick={downloadQR} className={classes.btn2}>Download</Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* How it works + What you get */}
            <Grid item xs={12} md={4}>
              <Grid>
                <Box className={classes.howItWorks}>
                  <Typography variant="h6" gutterBottom>
                    How It Works
                  </Typography>
                  <ol>
                    <li>
                      <b>Share Your Unique Referral Link</b>
                    </li>
                    <Typography variant="body2">
                      Send it via WhatsApp, SMS, Email, or Social Media.
                    </Typography>

                    <li>
                      <b>They Sign Up & Take Action</b>
                    </li>
                    <Typography variant="body2">
                      If they book a demo or enroll, it's considered successful.
                    </Typography>

                    <li>
                      <b>You Earn Rewards Instantly</b>
                    </li>
                    <Typography variant="body2">
                      Get cashback or wallet credit instantly.
                    </Typography>
                  </ol>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.howItWorks}>
                  <Typography variant="h6" gutterBottom>
                    What You Get
                  </Typography>
                  <ul>
                    <li>
                      <Typography variant="body2">
                        Instant Wallet Credit
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        No Limit on Referrals
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        Exclusive Monthly Bonuses
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {/* Referral & Wallet */}

          <Grid className={classes.howItWorks} style={{ marginTop: "1.5rem" }}>
            Spread the Word. Reap the Rewards.Help others discover the smarter
            way to prepare for competitive exams—and enjoy the benefits
            together.
          </Grid>
        </Paper>
      </Box>
      <Grid container spacing={2} mt={4}>
        <Grid item xs={12} md={6}>
          <Paper className={`${classes.paper} ${classes.paper2}`} elevation={1}>
            <Box
              className={`${classes.walletBox} ${classes.qrDetailBoxHeading}`}
            >
              <Typography
                variant="h5"
                className={classes.boldHeading}
                style={{ marginBottom: "0.5rem" }}
              >
                Referral Earned Till Date
              </Typography>
              <Typography variant="h4" className={classes.boldHeading}>
                <span className={classes.rupeeIcon}>₹</span>
                {Number(totalEarning || 0)
                  .toFixed(2)
                  .padStart(5, "0")}
              </Typography>
            </Box>
            <img
              src={next}
              alt="next"
              style={{ height: "50px", cursor: "pointer" }}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper className={`${classes.paper} ${classes.paper2}`} elevation={1}>
            <Box
              className={`${classes.walletBox} ${classes.qrDetailBoxHeading}`}
            >
              <Typography
                variant="h5"
                className={classes.boldHeading}
                style={{ marginBottom: "0.5rem" }}
              >
                My Wallet{" "}
              </Typography>
              <Typography variant="h4" className={classes.boldHeading}>
                <span className={classes.rupeeIcon}>₹</span>
                {Number(totalBalance || 0)
                  .toFixed(2)
                  .padStart(5, "0")}
              </Typography>
            </Box>
            <img
              src={next}
              alt="next"
              style={{ height: "50px", cursor: "pointer" }}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default ReferAndEarn;
